document.addEventListener('DOMContentLoaded', function () {
  
  //const spending = window.customerSpending || 6500; // Replace with dynamic value
  const spending = window.customerSpending;
  const tiers = [0, 300, 1000, 7000];
  const tierNames = ['Basic', 'Bronze', 'Gold', 'Diamond'];
  const maxTier = tiers[3];
  let currentTier = tiers[0];
  for (let i = 0; i < tiers.length; i++) {
    if (spending >= tiers[i]) {
      currentTier = i;
    } else {
      break;
    }
  }
  

 
  
  const tooltip = document.getElementById('spending-tooltip');
  const progressBarImage = document.getElementById('membership-bar-image');
  
  
  const spendingInTier = spending - tiers[currentTier];
  const tierRange = tiers[currentTier + 1] - tiers[currentTier];
  const percent = (spendingInTier / tierRange) * 100;
  
  // Determine which image to show based on percentage
  let imageIndex = 4; // Default to the last image (100%)
  if (percent < 25) {
    imageIndex = 0;
  } else if (percent < 50) {
    imageIndex = 1;
  } else if (percent < 75) {
    imageIndex = 2;
  } else if (percent < 100) {
    imageIndex = 3;
  }
  
  
  if (progressBarImage) {
    progressBarImage.src = mc_vip_progress_pills_images[imageIndex];
  }

  // Determine next tier
  let nextTierIndex = tiers.findIndex(t => spending < t);
  if (nextTierIndex === -1) {
    tooltip.textContent = `Diamond achieved 🎉`;
  } else {
    const nextTierName = tierNames[nextTierIndex];
    const nextTierAmount = tiers[nextTierIndex];
    const remaining = nextTierAmount - spending;
    tooltip.textContent = `RM${remaining.toFixed(2)} to ${nextTierName}`;
  }
});